import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { PageMeta } from './PageMeta'
import { ShowcaseReviewDto } from './ShowcaseReviewDto'
/**
* Class PageOfShowcaseReviewDto
*  Результат постраничного запроса
*/
export class PageOfShowcaseReviewDto extends ActiveModel {

  /**
  * meta
  * Meta-информация о результате постраничного запроса  */
  @ActiveField({
    factory: [PageMeta, () => undefined]
  })
  meta?: PageMeta


/**
  * @property items
  * Список элементов страницы<br>  */
  @ActiveField({
    factory: [ShowcaseReviewDto, () => undefined]
  })
  items?: Array<ShowcaseReviewDto>
}
